// The scroll position as the last scroll event left it, for code that runs in a frame
// callback. Reading `window.scrollX` or `scrollY` forces a layout if any style changed since
// the last one, and frame callbacks often run right after another part wrote its styles. With
// live reads, every scroll event forced one layout and every wave about 30.
//
// A frame runs its scroll events before its animation callbacks, so inside a callback this
// copy is the same as a live read. The listener captures on the window, so it runs before the
// parts' own scroll listeners. It starts on the first read, so it doesn't matter which order
// the parts start in.

let x = 0;
let y = 0;

function read(): void {
  x = window.scrollX;
  y = window.scrollY;
}

let watching = false;

function watch(): void {
  if (watching) return;
  watching = true;
  read();
  window.addEventListener("scroll", read, { capture: true, passive: true });
}

export function pageScrollX(): number {
  watch();
  return x;
}

export function pageScrollY(): number {
  watch();
  return y;
}
